import { render } from "./editnews.vue?vue&type=template&id=0acd82d8&scoped=true"
import script from "./editnews.vue?vue&type=script&lang=js"
export * from "./editnews.vue?vue&type=script&lang=js"

import "./editnews.vue?vue&type=style&index=0&id=0acd82d8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acd82d8"]])

export default __exports__